import { z } from 'zod';
export function safeProjectPath(path) {
    return (!path.startsWith('/') &&
        !path.includes('\\') &&
        // Reject control characters deliberately; filenames are displayed in feedback and logs.
        // eslint-disable-next-line no-control-regex
        !/[\u0000-\u001f\u007f]/.test(path) &&
        !path
            .split('/')
            .some((part) => !part ||
            part === '..' ||
            part === '.' ||
            /^(\.env.*|\.git|\.ssh|\.aws|\.mio.*|node_modules|\.venv|venv|__pycache__|\.pytest_cache|dist|build|coverage|credentials.*|.*\.(pem|key))$/i.test(part)));
}
export const projectArtifactSchema = z
    .object({
    files: z
        .array(z.object({ path: z.string().max(256), content: z.string().max(262_144) }))
        .max(200),
})
    .strict()
    .superRefine((artifact, context) => {
    const paths = new Set(artifact.files.map((file) => file.path));
    if (artifact.files.some((file) => {
        const segments = file.path.split('/');
        const invalidText = file.content.includes('\0') ||
            /[\uD800-\uDFFF]/.test(file.content.replace(/[\uD800-\uDBFF][\uDC00-\uDFFF]/g, ''));
        return (!safeProjectPath(file.path) ||
            invalidText ||
            new TextEncoder().encode(file.content).byteLength > 262_144 ||
            segments.some((_, index) => index > 0 && paths.has(segments.slice(0, index).join('/'))));
    }) ||
        paths.size !== artifact.files.length ||
        new TextEncoder().encode(JSON.stringify(artifact)).byteLength > 1_000_000) {
        context.addIssue({ code: 'custom', message: 'Unsafe or oversized project artifact' });
    }
});
/** One canonical source representation for bridge captures, S3 hashes and task publication. */
export function serializeProjectArtifact(artifact) {
    return JSON.stringify({
        files: [...artifact.files]
            .sort((a, b) => (a.path < b.path ? -1 : a.path > b.path ? 1 : 0))
            .map(({ path, content }) => ({ path, content })),
    });
}
